<script setup lang="ts">
import './realestate_cell.scss'

interface Props {
  data: object | string | number,
  cellConfig: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <div class="realestate-cell flex">
    <div class="thumb">
      <img :src="props.data?.thumb"  />
    </div>
    <div class="flex flex-col">
      <div class="font-bold">{{props.data?.title}}</div>
      <div>{{props.data?.region}}</div>
    </div>
  </div>
</template>

<style scoped>

</style>
